import { TOOLTIP_ARROW_SIZE } from './Tooltip.constants';
import { PositionsStyles, TooltipProps } from './types';

interface Params {
  color: TooltipProps['color'];
  positionRef: HTMLSpanElement | null;
  tooltipRef: HTMLDivElement | null;
}

const defaultDomRect = {
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  y: 0,
  x: 0,
};

export const getStylesByPosition = ({
  color,
  positionRef,
  tooltipRef,
}: Params): PositionsStyles => {
  const position = positionRef?.getBoundingClientRect() ?? defaultDomRect;
  const tooltip = tooltipRef?.getBoundingClientRect() ?? defaultDomRect;

  return {
    top: {
      top: position.y - tooltip.height - TOOLTIP_ARROW_SIZE - 2,
      left: position.x + position.width / 2 - tooltip.width / 2,
      '::before': {
        top: '100%',
        left: `calc(50% - ${TOOLTIP_ARROW_SIZE}px)`,
        borderTop: `${TOOLTIP_ARROW_SIZE}px solid ${color}`,
      },
    },
    right: {
      top: position.top - tooltip.height / 2 + position.height / 2,
      left: position.left + position.width + 10,
      '::before': {
        right: '100%',
        top: `calc(50% - ${TOOLTIP_ARROW_SIZE}px)`,
        borderRight: `${TOOLTIP_ARROW_SIZE}px solid ${color}`,
      },
    },
    bottom: {
      top: position.top + position.height,
      left: position.left - tooltip.width / 2 + position.width / 2,
      '::before': {
        left: `calc(50% - ${TOOLTIP_ARROW_SIZE}px)`,
        bottom: '100%',
        borderBottom: `${TOOLTIP_ARROW_SIZE}px solid ${color}`,
      },
    },
    left: {
      top: position.top - tooltip.height / 2 + position.height / 2,
      left: position.left - tooltip.width - 10,
      '::before': {
        left: '100%',
        top: `calc(50% - ${TOOLTIP_ARROW_SIZE}px)`,
        borderLeft: `${TOOLTIP_ARROW_SIZE}px solid ${color}`,
      },
    },
  };
};
